import classNames from 'classnames';

import { usePostContentContext } from '@/postContentElement/context';

import { embedDescriptionContainer, embedDescriptionParagraph } from './GenericEmbedDescription.css';
import type { TPostGenericEmbedDescriptionProps } from './GenericEmbedDescription.types';

export const PostGenericEmbedDescription = ({ element, children, editorMode }: TPostGenericEmbedDescriptionProps) => {
  const { postTheme } = usePostContentContext();
  const textContent = element?.content?.[0]?.text;
  const isHidden = postTheme?.hyperlink_hide_description === 'true';

  if (!editorMode && (!textContent || isHidden)) return null;

  return (
    <div
      data-generic-embed-description
      className={classNames(embedDescriptionContainer, editorMode && isHidden && 'hidden')}
    >
      <p className={embedDescriptionParagraph}>{editorMode ? children : textContent}</p>
    </div>
  );
};
